



































































































































































import Vue from "vue";
import { objectsSummary } from "@/common/api/summary.api";
import { getEntityById } from "@/common/api/entities.api";
import { ref, onMounted, onBeforeUnmount, watch } from "@vue/composition-api";
import { state } from "../data/state";
import { isEmpty, emptyFn } from "@/fp";
import { AppAnalytics } from "@/analytics";
import { POPULATION_TYPE } from "@/common/models";
import ClusterLabelBar from "./ClusterLabelBar.vue";
import { UseModal } from "@/components/root/modal";
import EventsModalVue from "@/components/modals/events-modal/EventsModal.vue";
import { EventsModalProps } from "@/components/modals/events-modal/model";
import { cord3 } from "@/gql/lib";
import { AxisType, TimeAxisType } from "@/gql/types";
import FilesModalVue from "@/components/modals/files-modal/FilesModal.vue";
import { FilesModalProps } from "@/components/modals/files-modal/model";
import Processing from "@/components/table/Processing.vue";
export default Vue.extend({
  components: { /* ClusterLabelBar, */ Processing },
  setup() {
    /* 
      - set cluster label
      - display cluster label
      - display time frame first & last
    */
    const { current_subject, cluster } = state;

    const summary = ref({
      filesInCluster: 0,
      eventsInCluster: 0,
      firstExposer: { id: "", name: "" },
      lastExposer: { id: "", name: "" },
      isNeverExposed: false,
    });
    const is_event_max_achieved = ref(false);
    const showSummary = async (clusterUID: string) => {
      const res = await objectsSummary({
        ids: [clusterUID],
        type: "clusters",
      });
      if (res.success) {
        //@ts-ignore
        is_event_max_achieved.value = res.value[0].eventMaxAchived;
        if (!is_event_max_achieved.value) {
          summary.value = res.value[0] as any;
        }
      }
    };

    const investigate = async (user: { id: string; objectName: string }) => {
      console.log("investigate user: ", user);
      AppAnalytics.report({
        component: "Investigation",
        eventName:
          "user clicked on an entity to investigate inside the cluster summary drawer",
      });
      const res = await getEntityById(user.id);
      if (res.success) {
        const { isExternal } = res.value;
        let email = "";
        if (res.value.externalId) {
          try {
            email = JSON.parse(res.value.externalId).userId;
          } catch (e) {
            console.log("error parsing user.externalId");
          }
        }
        state.investigate({
          id: user.id,
          name: user.objectName,
          email: !isExternal ? email : "",
          type: isExternal ? POPULATION_TYPE.CONTACT : POPULATION_TYPE.EMPLOYEE,
        });
      }
    };

    const show_files = () => {
      const modal_props: FilesModalProps = {
        files_only: true,
        files_title: `Content in the cluster of <b>${current_subject.value.name}</b>`,
        clusterUID: current_subject.value.cluster_id!,
        coordinates: [
          {
            x: cord3(AxisType.None, ["none"]),
            y: cord3(AxisType.None, ["none"]),
            z: {
              type: TimeAxisType.Month,
              values: [],
            },
          },
        ],
      };
      UseModal().show(FilesModalVue, modal_props);
    };

    const show_events = () => {
      const modal_props: EventsModalProps = {
        events_only: true,
        clusterUID: current_subject.value.cluster_id!,
        files_title: "",
        hide_filters: [],
        title: `Events in the cluster of <b>${current_subject.value.name}</b>`,
        coordinates: [
          {
            x: cord3(AxisType.None, ["none"]),
            y: cord3(AxisType.None, ["none"]),
            z: {
              type: TimeAxisType.Month,
              values: [],
            },
          },
        ],
      };
      UseModal().show(EventsModalVue, modal_props);
    };

    const subs = {
      subject: emptyFn(),
    };

    onMounted(() => {
      AppAnalytics.report({
        component: "Investigation",
        eventName: "user open cluster summary drawer",
      });
      subs.subject = watch(
        current_subject,
        ({ id }, oldView) => {
          if ((id && isEmpty(oldView)) || id !== oldView.id)
            showSummary(current_subject.value.cluster_id!);
        },
        {
          deep: true,
          lazy: false,
        }
      );
    });

    onBeforeUnmount(() => {
      Object.values(subs).forEach((unsub) => unsub());
    });

    return {
      summary,
      investigate,
      is_event_max_achieved,
      show_files,
      show_events,
      can_cluster_be_displayed: cluster.can_cluster_be_displayed,
      info_types: cluster.file_labels,
      first_exposure: cluster.first_cluster_time,
      last_exposure: cluster.last_cluster_time,
      is_loading_cluster: cluster.is_loading,
    };
  },
});
